<template>
    <Navigation user="ABC" v-if="!$route.meta.hideNavbar" />
    <section class="bg-[#fafafa] pb-[100px] font-[350] font-poppins">
        <router-view />
    </section>
    <FooterDesktop />
</template>

<script lang="ts" setup>
    import Navigation from '@/components/Structure/Navigation.vue'
    import FooterDesktop from '@/components/Structure/Footer.vue'
</script>

<style src="@/style.css"></style>
<style src="@/assets/vendor/bootstrap-icons/bootstrap-icons.css"></style>
